import axios from 'axios';

const api = axios.create({
 // baseURL: 'http://localhost/job-platform/backend/',
 baseURL: 'https://www.sustenidos.org.br/oportunidades-rh/backend/',
});

export default api;
